export default __webpack_public_path__ + "static/media/reminder-filter-icon.b2ef7692.svg";